export type KemCardActionTypes =
  | 'appleWallet'
  | 'googleWallet'
  | 'cardInfo'
  | 'changeStyle'
  | 'lockCard'
  | 'unlockCard'
  | 'manageCard'
  | 'addToWallet'

export interface KemCardActionsType {
  translationKey: string
  iconName: string
  action: KemCardActionTypes
  parentAction?: string
}

interface KemCardActionsParams {
  isLocked?: boolean
}

export const kemCardActions = ({
  isLocked = false,
}: KemCardActionsParams): KemCardActionsType[] => [
  {
    translationKey: 'translation:kemCard.appleWallet',
    iconName: 'wallet',
    action: 'appleWallet',
  },
  {
    translationKey: 'translation:kemCard.googleWallet',
    iconName: 'googlePay',
    action: 'googleWallet',
  },
  {
    translationKey: 'translation:kemCard.addToWallet',
    iconName: 'wallet',
    action: 'addToWallet',
  },
  {
    translationKey: 'translation:kemCard.manageCard',
    iconName: 'manage',
    action: 'manageCard',
  },
]

export const kemCardManageActions = ({
  isLocked = false,
}: KemCardActionsParams): KemCardActionsType[] => [
  {
    translationKey: 'translation:kemCard.cardInfo',
    iconName: 'cardFilled',
    action: 'cardInfo',
  },
  // {
  //   translationKey: 'translation:kemCard.changeStyle',
  //   iconName: 'edit',
  //   action: 'changeStyle',
  // },
  {
    translationKey: isLocked
      ? 'translation:kemCard.unlockCard'
      : 'translation:kemCard.lockCard',
    iconName: isLocked ? 'unlockFilled' : 'lock',
    action: isLocked ? 'unlockCard' : 'lockCard',
  },
]

export const addToWalletActions = ({
  isLocked = false,
}: KemCardActionsParams): KemCardActionsType[] => [
  {
    translationKey: 'translation:kemCard.appleWallet',
    iconName: 'wallet',
    action: 'appleWallet',
    parentAction: 'addWallet',
  },
  {
    translationKey: 'translation:kemCard.googleWallet',
    iconName: 'googlePay',
    action: 'googleWallet',
    parentAction: 'addWallet',
  },
]
